import type { Pagination } from 'models';
import { generateQueryKey } from 'query';
import type { TransactionsListFilter } from '../types';

type TransactionsParams = {
  filter?: Partial<TransactionsListFilter>;
  pagination?: Partial<Pagination>;
};

const transactionsQueryKey = 'transactions';

export const getTransactionsQueryKey = ({ filter = {}, pagination = {} }: TransactionsParams) =>
  generateQueryKey([transactionsQueryKey, { filter, pagination }]);

export const getTransactionsInfiniteQueryKey = (params: TransactionsParams = {}) =>
  generateQueryKey([...getTransactionsQueryKey(params), 'infinite']);
